import { createEntityAdapter, createSelector } from "@reduxjs/toolkit";
import { PartyInvolved } from "../../../api/PartiesInvolved";
import { RootState } from "../../../../src/app/store";

export const partiesInvolvedAdapter = createEntityAdapter<
  PartyInvolved,
  string
>({
  selectId: (party) => party.party_id,
});

const partiesSelectors = partiesInvolvedAdapter.getSelectors(
  (state: any) => state.partiesInvolvedData.parties
);

export const selectPartiesInvolvedCaseId = (state: any) =>
  state.partiesInvolvedData.caseId;
export const selectAllPartiesInvolved = partiesSelectors.selectAll;
export const selectPartiesInvolvedById = partiesSelectors.selectById;
export const selectPartiesInvolvedTotal = partiesSelectors.selectTotal;

export const selectHasPartiesInvolvedData = (state: any) =>
  selectPartiesInvolvedTotal(state) > 0;
export const selectPartiesInvolvedStatus = (state: any) =>
  state.partiesInvolvedData.status;
export const selectPartiesInvolvedError = (state: any) =>
  state.partiesInvolvedData.error;

export const selectPartiesWithRecommendedAction = createSelector(
  selectAllPartiesInvolved,
  (allParties) =>
    allParties.filter(
      (party) =>
        party.recommended_actions !== null &&
        party.recommended_actions !== undefined &&
        party.recommended_actions.length > 0
    )
);

export const selectPartyOptions = (state: any) =>
  state.partiesInvolvedData.partyOptions;
export const selectPartyOptionsStatus = (state: any) =>
  state.partiesInvolvedData.partyOptionsStatus;
export const selectPartyOptionsError = (state: any) =>
  state.partiesInvolvedData.partyOptionsError;

export const getPartyNameById = (partyId: string) =>
  createSelector(
    [(state: RootState) => state],
    (state) => {
      const party = selectPartiesInvolvedById(state, partyId);
      return party?.name || partyId;
    }
  );

export const getPartiesByIds = (partyIds: string[]) => (
  (state: RootState) => {
    const result: Record<string, PartyInvolved> = {};

    partyIds.forEach((partyId) => {
      result[partyId] = selectPartiesInvolvedById(state, partyId);
    });

    return result;
  }
);

export const selectSCNParties = createSelector(
  selectPartiesWithRecommendedAction,
  (parties) =>
    parties.filter((party) =>
      party.recommended_actions?.includes(
        "Issue Show Cause Notice",
      ),
    ),
);
  
  